(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initMarquee = (root = document) => {
    if (prefersReducedMotion.matches) {
      return;
    }

    const tracks = root.querySelectorAll('.announcement-marquee__track');
    tracks.forEach((track) => {
      const viewport = track.closest('.announcement-marquee__viewport');
      if (!viewport) return;

      track.querySelectorAll('[data-generated-clone="true"]').forEach((node) => node.remove());

      const baseNodes = Array.from(track.children).filter((node) => {
        if (node.dataset.generatedClone === 'true') return false;
        if (node.classList.contains('announcement-marquee__item--clone')) return false;
        if (node.classList.contains('announcement-marquee__separator--clone')) return false;
        return (
          node.classList.contains('announcement-marquee__item') ||
          node.classList.contains('announcement-marquee__separator')
        );
      });

      const hasItems = baseNodes.some((node) => node.classList.contains('announcement-marquee__item'));
      if (!hasItems) return;

      const viewportWidth = viewport.getBoundingClientRect().width;
      if (!viewportWidth) return;

      let trackWidth = track.scrollWidth;

      while (trackWidth < viewportWidth * 2) {
        const fragment = document.createDocumentFragment();
        baseNodes.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.dataset.generatedClone = 'true';
          clone.setAttribute('aria-hidden', 'true');

          if (clone.classList.contains('announcement-marquee__item')) {
            clone.classList.add('announcement-marquee__item--clone');
            clone.querySelectorAll('a, button, input, select, textarea').forEach((focusable) => {
              focusable.setAttribute('tabindex', '-1');
              focusable.setAttribute('aria-hidden', 'true');
            });
          } else if (clone.classList.contains('announcement-marquee__separator')) {
            clone.classList.add('announcement-marquee__separator--clone');
          }

          fragment.appendChild(clone);
        });

        track.appendChild(fragment);
        trackWidth = track.scrollWidth;
      }
    });
  };

  // Pause/play (WCAG 2.2.2). The choice is remembered for the visitor, because
  // the bar is on every page and a pause that resets on each page view is no
  // pause at all. Storage can throw (private mode, blocked site data): the
  // button still works for the current page without it.
  const PAUSE_KEY = 'jnco:marquee-paused';

  const readPaused = () => {
    try {
      return window.localStorage.getItem(PAUSE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const writePaused = (paused) => {
    try {
      if (paused) window.localStorage.setItem(PAUSE_KEY, '1');
      else window.localStorage.removeItem(PAUSE_KEY);
    } catch (error) {
      /* storage unavailable */
    }
  };

  // The control is either the transparent overlay over the messages (default:
  // click or tap anywhere on the bar) or, when a message is a link, a small
  // visible button. Both carry data-marquee-toggle.
  const setPaused = (bar, paused) => {
    bar.classList.toggle('announcement-marquee--paused', paused);
    const toggle = bar.querySelector('[data-marquee-toggle]');
    if (!toggle) return;
    const label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
    toggle.setAttribute('aria-label', label);
    if (toggle.hasAttribute('title')) toggle.setAttribute('title', label);
  };

  const initToggles = (root = document) => {
    const paused = readPaused();
    root.querySelectorAll('[data-marquee-toggle]').forEach((toggle) => {
      const bar = toggle.closest('.announcement-marquee');
      if (!bar) return;
      setPaused(bar, paused);
      toggle.hidden = false;
      // The overlay lies under the messages; this lets clicks fall through to it.
      if (toggle.classList.contains('announcement-marquee__overlay')) {
        bar.classList.add('announcement-marquee--overlay-ready');
      }
      if (toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', () => {
        const next = !bar.classList.contains('announcement-marquee--paused');
        writePaused(next);
        // Hands the bar to the shopper: pause-on-hover stops applying (CSS).
        bar.classList.add('announcement-marquee--toggled');
        setPaused(bar, next);
      });
    });
  };

  const debouncedInit = (() => {
    let timeoutId;
    return () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => initMarquee(document), 150);
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initToggles(document);
      initMarquee(document);
    });
  } else {
    initToggles(document);
    initMarquee(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initToggles(event.target);
    initMarquee(event.target);
  });

  window.addEventListener('resize', debouncedInit);

  if (typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document
          .querySelectorAll('[data-generated-clone="true"]')
          .forEach((node) => node.remove());
      } else {
        initMarquee(document);
      }
    });
  }
})();
